import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import InfiniteLoading from 'vue-infinite-loading'
import VeeValidate from 'vee-validate'
import VCalendar from 'v-calendar'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing)
Vue.use(BootstrapVue)
Vue.use(InfiniteLoading)
Vue.use(VeeValidate, { events: 'input' })
Vue.use(VCalendar, {
  componentPrefix: 'vc'
})
